(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tf-product-ui-optimization"] && !Shopify.designMode) return;
  try {
    (() => {
    const sticky = document.querySelector('.m-sticky-addtocart[data-show-on-mobile="true"]');
    const root = document.documentElement;
    const mobile = window.matchMedia('(max-width: 749px)');
    const interactiveSelector = [
      'a[href]',
      'button',
      'input:not([type="hidden"])',
      'select',
      'textarea',
      'summary',
      '[role="button"]',
      '[role="link"]',
      '[role="radio"]',
      '[role="slider"]'
    ].join(',');
    let frame = 0;
    let collisionFrame = 0;
    let collisionObserver;
    let chatStateObserver;
    let observedChatRoot;
    const obstructingControls = new Set();

    const getChatState = () => {
      const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
      const runtime = chatRoot?.querySelector('shopify-agent-runtime');
      const activator = chatRoot?.querySelector('[part="activator"]')
        || runtime?.shadowRoot?.querySelector('[part="activator"]');
      const open = runtime?.hasAttribute('open')
        || activator?.getAttribute('aria-expanded') === 'true';

      return { activator, chatRoot, open };
    };

    const updateCollisionState = () => {
      const { open } = getChatState();
      root.classList.toggle('tf-inbox-open', open);
      root.classList.toggle(
        'tf-inbox-overlap-risk',
        mobile.matches && !open && obstructingControls.size > 0
      );
    };

    const configureCollisionObserver = () => {
      collisionFrame = 0;
      collisionObserver?.disconnect();
      obstructingControls.clear();

      const { activator, chatRoot, open } = getChatState();

      if (chatRoot && chatRoot !== observedChatRoot) {
        chatStateObserver?.disconnect();
        chatStateObserver = new MutationObserver(queueCollisionObserver);
        chatStateObserver.observe(chatRoot, {
          attributes: true,
          attributeFilter: ['aria-expanded', 'open'],
          childList: true,
          subtree: true
        });
        observedChatRoot = chatRoot;
      }

      if (!mobile.matches || !activator || open) {
        updateCollisionState();
        return;
      }

      const rect = activator.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const top = Math.max(0, Math.min(viewportHeight, rect.top));
      const right = Math.max(0, Math.min(viewportWidth, rect.right));
      const bottom = Math.max(0, Math.min(viewportHeight, rect.bottom));
      const left = Math.max(0, Math.min(viewportWidth, rect.left));

      if (right <= left || bottom <= top) {
        updateCollisionState();
        return;
      }

      const rootMargin = [
        `-${top}px`,
        `-${viewportWidth - right}px`,
        `-${viewportHeight - bottom}px`,
        `-${left}px`
      ].join(' ');

      collisionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            obstructingControls.add(entry.target);
          } else {
            obstructingControls.delete(entry.target);
          }
        });
        updateCollisionState();
      }, {
        rootMargin,
        threshold: 0.001
      });

      document.querySelectorAll(interactiveSelector).forEach((control) => {
        if (!control.closest('shopify-chat, shopify-agent')) {
          collisionObserver.observe(control);
        }
      });
    };

    const queueCollisionObserver = () => {
      if (collisionFrame) return;
      collisionFrame = window.requestAnimationFrame(configureCollisionObserver);
    };

    const update = () => {
      frame = 0;

      if (sticky) {
        const rect = sticky.getBoundingClientRect();
        const visible_pixels = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
        const visible = rect.height > 0 && visible_pixels >= Math.min(48, rect.height * .6);
        root.classList.toggle('tf-native-sticky-visible', visible);
      }
    };

    const queue = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    if (sticky) {
      new MutationObserver(queue).observe(sticky, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    window.addEventListener('resize', queue, { passive: true });
    window.addEventListener('resize', queueCollisionObserver, { passive: true });
    window.addEventListener('scroll', queue, { passive: true });
    window.visualViewport?.addEventListener('resize', queueCollisionObserver, { passive: true });
    mobile.addEventListener('change', queueCollisionObserver);
    document.addEventListener('shopify:section:load', queueCollisionObserver);
    customElements.whenDefined('shopify-chat').then(queueCollisionObserver);
    window.setTimeout(queueCollisionObserver, 1000);
    queue();
    queueCollisionObserver();
  })();
  } catch(e) { console.error(e); }
})();

})();
